<template>
    <!--基本设置-->
    <div class="_companyinfo">
        <div class="head">
            <span class="title">基本设置</span>
        </div>
        <div class="setting">
            <label>
                <span class="setting-title">
                    新加入成员必填审核资料
                </span>
                <i-switch v-model="baseSetting.is_check_new" @on-change="changeSetting">
                    <span slot="open">开</span>
                    <span slot="close">关</span>
                </i-switch>
            </label>
        </div>
    </div>

</template>

<script>
    import $api from "@/service/index"

    export default {
        name: "setting",
        data() {
            return {
                baseSetting: {
                    "is_check_new": false,   //	是否开启新加入成员必填审核资料
                }
            }
        },
        mounted() {
            this.getDefaultSetting();
        },
        methods : {
            //获取单位默认基本设置
            getDefaultSetting(){
                let _self = this;
                $api.getCompanySetting().then(data=>{
                     _self.baseSetting = data;
                });
            },
            /**
             * 基本设置中开关change事件
             * @param {string} status 开关状态
             */
            changeSetting(status){
                let _self = this;
                _self.baseSetting.is_check_new = !status;
                $api.setCompanySetting(_self.baseSetting.is_check_new ? "0" : "1").then(data => {
                    _self.baseSetting.is_check_new = status;
                    this.$Message.success('修改成功！');
                });
            }
        },
        watch : {
            baseSetting(){
                this.baseSetting.is_check_new = (this.baseSetting.is_check_new ==="0"||this.baseSetting.is_check_new===false) ? false :true;
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "./setting";
</style>


// WEBPACK FOOTER //
// src/pages/company/baseinfo/business/Setting.vue